/* eslint-disable import/prefer-default-export */
import logMessageWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import { Authorize, getPkceCodeVerifier } from '@hmh/eds-login-js';
import {
  getIdentifiedPlatformClientId,
  getIdentifiedPlatformConfig,
  identifyPlatform,
  ISSUER_URL,
} from '@hmhco/login-config';
import { PLATFORMS } from '@hmhco/amp-core-env';
import { getSignedInUrl } from './getSignedInUrl';

export async function authorize({
  pid,
  loginHint,
  isPidFromUrl,
  resourceId,
  resourceUrl,
  /**
   * Options
   */
  onError,
  platform,
  codeChallenge,
} = {}) {
  if (typeof pid === 'undefined') {
    throw Error(`pid was not defined: "${pid}"`);
  }
  if (typeof loginHint === 'undefined') {
    throw Error(`loginHint was not defined: "${loginHint}"`);
  }
  if (typeof isPidFromUrl === 'undefined') {
    throw Error(`isPidFromUrl was not defined: "${isPidFromUrl}"`);
  }

  const { edsInitUrl, nweaIssuer } = getIdentifiedPlatformConfig();

  const isSecure = !!window.location.protocol.match('https:?');
  const pkceCodeChallengeMethod = isSecure ? 'S256' : 'plain';

  await getPkceCodeVerifier(pkceCodeChallengeMethod).then(
    ({ challenge, verifier }) => {
      sessionStorage.setItem('verifier', verifier);
      sessionStorage.setItem('challenge', challenge);
    },
  );

  const getIssuer = () => {
    if (platform === PLATFORMS.NWEA) {
      return nweaIssuer;
    }
    return ISSUER_URL;
  };

  try {
    const authorization = new Authorize(
      getIdentifiedPlatformClientId(),
      getIssuer(),
      edsInitUrl,
      {
        targetLinkUri: getSignedInUrl(),
      },
    );

    let codeChallengeVerifier = null;

    if (identifyPlatform() === PLATFORMS.AI_TOOLS && codeChallenge) {
      codeChallengeVerifier = {
        challenge: codeChallenge,
        code_challenge_method: 'S256',
        verifier: 'someverifier',
      };
      logMessageWithContext(
        'AI Tools platform code challenge verifier has been changed',
        [{ key: 'codeChallengeVerifier', value: codeChallengeVerifier }],
      );
    }

    const thirdPartyLoginUri = await authorization.getThirdPartyLoginUri({
      connection: pid,
      loginHint,
      ...(resourceId ? { resourceId } : {}),
      ...(resourceUrl ? { resourceUrl } : {}),
      ...(codeChallengeVerifier ? { codeChallengeVerifier } : {}),
      /**
       * SSO setting check false if pid is from URL
       * SSO setting check true if pid is from storage
       */
      ssoSettingCheck: !isPidFromUrl,
    });

    window.location = thirdPartyLoginUri;
  } catch (error) {
    onError?.(error);
  }
}
